export const getFieldTranslationKey = (fieldName) => {
  switch (fieldName) {
    case "project_id":
      return "project";
    default:
      return "";
  }
};
